import React from 'react';
import TableRow from 'components/Table/TableRow';
import TableBodyCell from 'components/Table/TableBodyCell';
import SkeletonRectangle from 'components/Skeleton/SkeletonRectangle';
import TableActionCell from 'components/Table/TableActionCell';
import { EmailsColumnSizes } from 'components/LoanOriginationSystem/EmailView/EmailAttachmentsTable/TableColumnSizes';

const SkeletonEmailAttachmentLine = () => {
  return (
    <TableRow disableHover useActions>
      <TableBodyCell width={EmailsColumnSizes.Name}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell width={EmailsColumnSizes.Format}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell width={EmailsColumnSizes.Size}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableActionCell />
    </TableRow>
  );
};

export default SkeletonEmailAttachmentLine;
